<template>
  <div class="manual">
    <h2><span style="font-weight: 300;">Campus Complex</span><br>Autumn Fellowship<br>2022 Guide</h2>
    <p>Learning links and resources.</p>

    <div class="manual-section">
      <h3>Calendar</h3>
      <LrftCalendar></LrftCalendar>
      <br>
      <!-- <a href="">Shared Google Calendar</a> -->
    </div>

    <div class="manual-section">
      <div class="spaces">
        <h3>Visiting Hours</h3>
        <p>To set up Visiting Hours, reach out to the Steward atleast a day in advance with what you want to explore – and check the calendar to confirm they haven't already scheduled time with another Fellow. We want to make sure they don't have more than one Visiting Hours in a day. <br><br>Your mission is to set up at least 4-6 Visiting Hours during the next 4 Quad Cycles! Feel free to stamp your Learner Card as many times as you'd like. Here are the times that Stewards are available:</p>
        <ul>
          <li>The Factory: 24/7</li>
          <li>The Garage: Wednesdays, 10a-7p</li>
          <li>Processa: Very Flexible</li>
          <li>Quay: Weekdays, 1-6p</li>
          <li>Eternal: Weekdays, 11a-6p</li>
          <li>Daze: TBD</li>
          <li>The Playground: Anydays, 12-3p</li>
        </ul>
        <p>When you confirm a Visiting Hours session, add it to the shared Google Calendar and drop a note in the Campus Complex chat to avoid scheduling conflicts and to give other Fellows an opportunity to join!</p>
        <br>
      </div>
    </div>

    <div class="manual-section">
      <div class="spaces">
        <h3>Encouragers</h3>
        <p>These folks are available to schedule a 1:1 with throughout the program.</p>
        <div class="space-details">
          <ul>
            <li class="encourager-item" v-for="(encourager, index) in $store.state.lrft.encouragers" :key="index">
              {{ encourager.name }}, {{ encourager.what }} - <a :href="encourager.phoneTel" target="_blank" rel="noopener">{{ encourager.phone }}</a>
            </li>
          </ul>
        </div>
        <br>
      </div>
    </div>

    <div class="manual-section">
      <div class="spaces">
        <h3>Spaces</h3>
        <br>
        <div class="space-item" v-for="(space, index) in $store.state.lrft.spaces" :key="index">
          <div class="space-details">
            <h4>{{ space.name }}</h4>
            <ul>
              <li><a :href="space.googleMapsLink">{{ space.address }}</a></li>
              <li v-if="space.visitingHours">{{ space.visitingHours }}</li>
              <li>Stewarded by {{ space.steward }} <a :href="space.phoneTel" target="_blank" rel="noopener" v-if="space.phone != ''">{{ space.phone }}</a></li>
              <li v-if="space.socialLink">Follow <a :href="space.socialLink" target="_blank" rel="noopener">{{ space.socialText }}</a></li>
            </ul>
          </div>
        </div>
        <br>
      </div>
    </div>

    <div class="manual-section">
      <h3>Code of Conduct</h3>
      <p>In short – be kind, be encouraging, and be respectful to the spaces, stewards, educators, and learners fostering these edcuational environments.</p>
      <p>Your participation in the Autumn Fellowship is an agreement to abide by the Campus Complex Code of Conduct and those of the Spaces you'll be visiting.</p>
      <ul>
        <li><a href="https://d1on0x8owq06rr.cloudfront.net/f513ba294f7781c1f5f2f2f272f2111a-ETERNAL%20HOUSE%20RULES.pdf" target="_blank">Eternal House Rules</a></li>
        <li>More To Be Linked!</li>
        <!-- <li><a href="">Campus Complex C.O.C</a></li> -->
        <!-- <li><a href="">The Garage C.O.C</a></li>
        <li><a href="">Quay C.O.C</a></li>
        <li><a href="">Eternal C.O.C</a></li>
        <li><a href="">Processa C.O.C</a></li> -->
      </ul>
    </div>

  </div>
</template>

<script>
import LrftCalendar from '@trust/components/LrftCalendar.vue'

export default {
  name: 'LrftManual',
  components: {
    LrftCalendar
  },
  data() {
      return {
      }
  },
  computed: {

  },
  mounted() {

  },
  methods: {
  },
}

</script>

<style>
.manual {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  overflow-y: scroll;
}

.manual-section {
  padding-top: 16px;
  border-top: 1px solid var(--beige-700);
  margin-top: 24px;
  margin-bottom: 24px;
}

.manual a {
  text-decoration: none;
  color: var(--beige-700);
}

.manual a:hover {
  cursor: pointer;
  color: var(--orange-500);
}

.manual h2 {
  line-height: 130%;
}

.manual h4 {
  margin: 0;
  margin-bottom: 4px;
  font-family: "Untitled Serif";
  font-size: 1rem;
  font-weight: 500;
}

.manual ul {
  margin-top: 0;
}

@media screen and (max-device-width: 600px){

}


</style>
